import { Link, useLocation } from 'react-router-dom';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import classes from 'components/common/Tables/Cells/RecommendationCell/RecommendationCell.module.scss';

export const RecommendationCell = ({ title, id, toggleRowSelected, toggleAllRowsSelected }) => {
    const { pathname, search } = useLocation();

    const handleSelectRow = () => {
        if (toggleRowSelected && toggleAllRowsSelected) {
            toggleAllRowsSelected(false);
            toggleRowSelected(true);
        }
    };

    return (
        <div className={classes.recommendationCell}>
            <CustomizedTooltip
                tooltipContent={title}
                triggerElement={
                    <Link
                        to={{
                            pathname: `${pathname}/card-${id}`,
                            search,
                        }}
                        className={classes.recommendationName}
                        onClick={handleSelectRow}
                    >
                        {title}
                    </Link>
                }
            />

            <div className={classes.recommendationId}>C-{id}</div>
        </div>
    );
};
